import Skeleton from 'react-loading-skeleton';

const ChartHeaderSkeleton = () => (
  <div className="text-center mb-6">
    <h4 className="text-lg font-semibold text-content-primary mb-2">
      <Skeleton width={150} />
    </h4>
    <div className="w-12 h-0.5 mx-auto">
      <Skeleton width={48} height={2} />
    </div>
  </div>
);

const UpcomingReviewsChartSkeleton = () => (
  <div>
    <ChartHeaderSkeleton />
    {/* UPDATED: Height changed from h-64 to h-72 to match the real component */}
    <div className="relative h-72 w-full overflow-hidden rounded-2xl bg-background-secondary/70 border border-border p-4">
      <Skeleton height="100%" />
    </div>
  </div>
);

const MilestonesSkeleton = () => (
  <div className="milestones-section">
    <div className="relative overflow-hidden rounded-2xl border border-border bg-background-secondary/70 p-6">
      <ChartHeaderSkeleton />
      {/* UPDATED: Grid classes now match the final responsive layout of the Milestones component */}
      <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} height={120} borderRadius={16} />
        ))}
      </div>
    </div>
  </div>
);

const CarouselRowSkeleton = () => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <Skeleton width={4} height={14} borderRadius={99} />
        <Skeleton width={110} height={12} />
      </div>
      <Skeleton width={70} height={12} />
    </div>
    <div className="flex items-center gap-2">
      <div className="flex-1">
        <Skeleton height={40} borderRadius={8} />
      </div>
      <Skeleton width={80} height={40} borderRadius={12} />
    </div>
  </div>
);

const ExtraStudyCardSkeleton = () => (
  <div className="rounded-2xl border border-border overflow-hidden">
    <ChartHeaderSkeleton />
    <div className="px-5 pb-3 flex flex-col gap-3">
      <CarouselRowSkeleton />
      <div className="border-t border-border" />
      <CarouselRowSkeleton />
    </div>
  </div>
);

const ExtraStudySkeleton = () => (
  <div>
    {/* Mobile: single card */}
    <div className="lg:hidden rounded-2xl border border-border overflow-hidden">
      <div className="flex border-b border-border">
        <div className="flex-1 py-3 flex justify-center"><Skeleton width={100} height={16} /></div>
        <div className="flex-1 py-3 flex justify-center"><Skeleton width={80} height={16} /></div>
      </div>
      <div className="px-5 py-3 flex flex-col gap-3">
        <CarouselRowSkeleton />
        <div className="border-t border-border" />
        <CarouselRowSkeleton />
      </div>
    </div>
    {/* Desktop: two cards */}
    <div className="hidden lg:grid lg:grid-cols-2 gap-6">
      <ExtraStudyCardSkeleton />
      <ExtraStudyCardSkeleton />
    </div>
  </div>
);

const DashboardContentTabsSkeleton = () => (
  <div className="overflow-hidden rounded-2xl bg-background-secondary shadow-md">
    {/* Mock Tab Buttons */}
    <div className="flex tab-navigation border-b-2 border-border">
      {/* UPDATED: Changed from flex-1 to w-1/3 to match the real component */}
      <div className="w-1/3 px-2 sm:px-4 py-4 flex justify-center">
        <Skeleton width={80} height={24} />
      </div>
      <div className="w-1/3 px-2 sm:px-4 py-4 flex justify-center">
        <Skeleton width={80} height={24} />
      </div>
      <div className="w-1/3 px-2 sm:px-4 py-4 flex justify-center">
        <Skeleton width={80} height={24} />
      </div>
    </div>

    {/* Mock Tab Content (represents the default "Overview" tab) */}
    <div className="min-h-[400px] p-6">
      <div className="space-y-6">
        <ExtraStudySkeleton />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <UpcomingReviewsChartSkeleton />
          <UpcomingReviewsChartSkeleton />
        </div>
        <MilestonesSkeleton />
      </div>
    </div>
  </div>
);

export default DashboardContentTabsSkeleton;